// @flow
// idxgen-disable
// Please don't use it file for re-export or bootstrap

import { connectRoutes } from 'redux-first-router';
import createHistory from 'history/createBrowserHistory';

import { queryString } from 'common/utils';

import * as selectors from './selectors';
import routes from './routes';

const history = createHistory();

export const { reducer, middleware, enhancer, initialDispatch } = connectRoutes(history, routes, {
  location: selectors.rootModule,
  querySerializer: queryString,
  initialDispatch: false,
});



// WEBPACK FOOTER //
// ./src/modules/router/index.js